/*@flow*/
import type { Node } from 'react';
import React, { useEffect, useState } from 'react';
import FreeModal from 'comps/FreeModal';
import Form from './Form';
import type { DocumentNode } from 'graphql';

type PropsT = {
  isOpen: boolean,
  isLoading?: boolean,
  naked?: boolean,
  closeWithoutPrompt?: boolean,
  onClose: Function,
  onChange?: Function,
  onSave?: Function,
  variableTransformer?: Function,
  afterSuccess?: Function,
  mutation: DocumentNode,
  refetchQueries?: Object[],
  queryName: string,
  namespace: string,
  title: string | React$Node,
  value?: Object,
  schema: Object,
};

const Component = (props: PropsT): Node => {
  const [value2, setValue2] = useState(props.value);
  const [mutated, setMutated] = useState(false);

  useEffect(() => {
    setValue2(props.value);
  }, [props.value]);

  const onRequestClose = () => () => {
    if (props.closeWithoutPrompt || !mutated) {
      props.onClose();
    } else {
      let res = confirm(
        'You have unsaved work. Are you sure you want to close this modal?'
      );
      if (res) {
        props.onClose();
      }
    }
  };

  return (
    <FreeModal
      id="data-modal"
      title={props.title}
      isOpen={props.isOpen}
      naked={props.naked}
      requestClosePortal={onRequestClose()}
    >
      {props.isLoading ? (
        <div className="text-flex-center" style={{ minHeight: 400 }}>
          Loading...
        </div>
      ) : (
        <Form
          value={value2}
          mutation={props.mutation}
          refetchQueries={props.refetchQueries}
          onClose={() => {
            setMutated(false);
            props.onClose();
          }}
          queryName={props.queryName}
          variableTransformer={props.variableTransformer}
          namespace={props.namespace}
          onSave={props.onSave}
          afterSuccess={props.afterSuccess}
          schema={props.schema}
          onChange={(value) => {
            setMutated(true);
            setValue2(value);
            props.onChange && props.onChange(value);
          }}
        />
      )}
    </FreeModal>
  );
};

export default Component;
